
import Vue from 'vue'
import objectPath from 'object-path'
import { profile } from '@/utils/mapping'

const mutations = {
  updateField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
  setUserForm(state, payload) {
    const {
      fullname,
      phone,
      email
    } = payload

    state.userForm = {
      fullname,
      phone,
      email
    }
  },
  setAgencyFormErrors(state, errors) {
    Vue.set(state, 'agencyFormErrors', errors.map(item => profile.formErrors(item)))
  },
  changeShowUserForm(state, payload) {
    state.showUserForm = payload
  },
  changeShowAgencyForm(state, payload) {
    state.showAgencyForm = payload
  }
}

export default mutations